import React, { createContext, useState, useEffect } from "react";
import { BASE_URL } from "../config/apiconfig";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch notifications from API
  const fetchNotifications = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${BASE_URL}/notifications`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        setNotifications(data.data || []);
      } else {
        console.error(
          "Failed to fetch notifications",
          data
        );
      }
    } catch (err) {
      console.error(
        "Failed to fetch notifications",
        err
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete notification by ID
  const deleteNotification = async (id) => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${BASE_URL}/notifications/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        setNotifications((prev) =>
          prev.filter((n) => n.id !== id)
        );
      } else {
        const data = await response.json();

        console.error(
          "Failed to delete notification",
          data
        );
      }
    } catch (err) {
      console.error(
        "Failed to delete notification",
        err
      );
    }
  };

  useEffect(() => {
    fetchNotifications();

    const interval = setInterval(() => {
      fetchNotifications();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        loading,
        fetchNotifications,
        deleteNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};